export function stripPracticeStrategyPrefix(
  text: string,
  strategyName: string,
) {
  const prefix = `${strategyName} - `;
  let strippedText = text;
  if (text.startsWith(prefix)) {
    strippedText = text.slice(prefix.length);
  } else {
    const escapedStrategyName = strategyName.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&",
    );
    const linkedPrefix = new RegExp(
      `^<a\\b[^>]*>${escapedStrategyName}</a>\\s*-\\s*`,
    );
    strippedText = text.replace(linkedPrefix, "");
  }

  if (strippedText === text) {
    return text;
  }

  let insideTag = false;
  for (let index = 0; index < strippedText.length; index += 1) {
    const character = strippedText[index];
    if (character === "<") {
      insideTag = true;
    } else if (character === ">") {
      insideTag = false;
    } else if (!insideTag && character === "&") {
      const entity = strippedText
        .slice(index)
        .match(/^&(?:#\d+|#x[\da-f]+|[a-z][\da-z]*);/i);
      if (entity) {
        index += entity[0].length - 1;
      }
    } else if (!insideTag && /[a-z]/.test(character)) {
      return `${strippedText.slice(0, index)}${character.toUpperCase()}${strippedText.slice(index + 1)}`;
    } else if (!insideTag && /[A-Z]/.test(character)) {
      return strippedText;
    }
  }

  return strippedText;
}

export function getPracticeTutorialStep(
  currentStep: number,
  direction: number,
  stepCount: number,
) {
  const nextStep = currentStep + direction;
  return nextStep >= -1 && nextStep < stepCount ? nextStep : null;
}

export function getPracticeTutorialCompletion(
  currentStep: number,
  stepCount: number,
  hasNextBoard: boolean,
) {
  const isComplete = stepCount > 0 && currentStep === stepCount - 1;
  return {
    isComplete,
    nextDisabled: isComplete && !hasNextBoard,
  };
}
